export const COMPLETED_BY_COLLEAGUE_KEY = 'onboarding.api.errors.onboarding.completed_by_colleague';
export const COLLEAGUE_FINALIZING_KEY = 'onboarding.api.errors.onboarding.colleague_finalizing';
export const ALREADY_COMPLETED_KEY = 'onboarding.api.errors.onboarding.already_completed';
export const RENEWAL_NOT_PERMITTED_KEY = 'onboarding.api.errors.onboarding.renewal_not_permitted';
